"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.cleanOrganisationMetadata = cleanOrganisationMetadata;
exports.organisationMetadataDSL = exports.agentMetadataDSL = exports.mapOrganisation = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _url = _interopRequireDefault(require("url"));

var _helpers = require("./utils/helpers");

var _suburbs2 = require("./utils/suburbs");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context26; (0, _forEach.default)(_context26 = ownKeys(Object(source), true)).call(_context26, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context27; (0, _forEach.default)(_context27 = ownKeys(Object(source))).call(_context27, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

var countries = {
  NZ: 'New Zealand',
  AU: 'Australia'
};

var mapAddress = function mapAddress(address) {
  var _context, _context2;

  var includeInvalid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!address) return undefined;

  if (!includeInvalid && !(address.countryCode && address.suburb && address.streetName)) {
    return undefined;
  }

  var location = address.location || {};
  var un = address.unitNumber || '';
  var unitNumber = /^\d+/.test(un) ? "Unit ".concat(un) : address.unitNumber;
  var streetAddress = (0, _filter.default)(_context = [unitNumber, address.propertyName, address.buildingName, (0, _filter.default)(_context2 = [address.streetNumber, address.streetName]).call(_context2, function (x) {
    return x;
  }).join(' ')]).call(_context, Boolean).join(', ');
  return {
    latitude: location.lat,
    longitude: location.lon,
    unitNumber: address.unitNumber,
    floorNumber: address.floorNumber,
    propertyName: address.propertyName,
    buildingName: address.buildingName,
    streetNumber: address.streetNumber,
    // $FlowFixMe checked above
    streetName: address.streetName,
    // $FlowFixMe checked above
    locality: address.suburb,
    region: address.state,
    stateCode: (0, _helpers.getStateCode)(address.state),
    state: address.state,
    postCode: address.postCode,
    // $FlowFixMe checked above
    country: address.country || countries[address.countryCode],
    // $FlowFixMe checked above
    countryCode: address.countryCode,
    streetAddress
  };
}; // Data for websites is pretty messy


var cleanWebsite = function cleanWebsite(site) {
  var _context3;

  var parts = /^https?:\/\//.test(site) ? _url.default.parse(site) : {
    hostname: site,
    protocol: 'http:'
  };
  if (!parts.hostname) return undefined;
  var hostname = parts.hostname.toLowerCase().replace(/(^[^a-z0-9]+|[^a-z0-9]+)$/, '');
  return (0, _concat.default)(_context3 = "".concat(parts.protocol || 'http:', "//")).call(_context3, hostname);
}; // Convert an arbitrary setting name into a useful lower camel cased version


var settingKey = function settingKey(key) {
  var _context4;

  var cased = key.replace(/[A-Z]{2,}/g, function (v) {
    return v.toLowerCase();
  }).replace(/\bid\b/i, 'ID').replace(/\s*\(([a-z0-9]+)\)/gi, function (_, v) {
    return " ".concat(v);
  }).replace(/(?:\s+|\.)([a-z])/gi, function (_, v) {
    return (0, _trim.default)(v).call(v).toUpperCase();
  }).replace(/(\s+|[^a-z0-9]+)/gi, '');
  return (0, _concat.default)(_context4 = "".concat(cased[0].toLowerCase())).call(_context4, (0, _slice.default)(cased).call(cased, 1));
};

var reduceSettings = function reduceSettings(settings) {
  return (0, _reduce.default)(settings).call(settings, function (acc, _ref) {
    var key = _ref.key,
        value = _ref.value;
    acc[settingKey(key)] = value;
    return acc;
  }, {});
};

var mapOrganisation = function mapOrganisation(data) {
  var id = data.id,
      parentId = data.parentId,
      _data$branchIds = data.branchIds,
      branchIds = _data$branchIds === void 0 ? [] : _data$branchIds,
      type = data.type,
      typeCode = data.typeCode,
      subType = data.subType,
      subTypeCode = data.subTypeCode,
      address = data.address,
      postalAddress = data.postalAddress,
      _data$address = data.address;
  _data$address = _data$address === void 0 ? {} : _data$address;
  var countryCode = _data$address.countryCode,
      brandName = data.brandName,
      emailAddress = data.emailAddress,
      name = data.name,
      secondName = data.secondName,
      _data$phones = data.phones,
      phones = _data$phones === void 0 ? [] : _data$phones,
      _data$teams = data.teams,
      teams = _data$teams === void 0 ? [] : _data$teams,
      _data$profile = data.profile;
  _data$profile = _data$profile === void 0 ? {} : _data$profile;

  var _data$profile$socialL = _data$profile.socialLinks,
      socialLinks = _data$profile$socialL === void 0 ? [] : _data$profile$socialL,
      _data$profile$photos = _data$profile.photos,
      _photos = _data$profile$photos === void 0 ? [] : _data$profile$photos,
      _data$profile$text = _data$profile.text,
      text = _data$profile$text === void 0 ? '' : _data$profile$text,
      testimonials = data.testimonials,
      licenceCode = data.licenceCode,
      userName = data.userName,
      webSite = data.webSite,
      _data$roles = data.roles,
      roles = _data$roles === void 0 ? [] : _data$roles,
      _data$awards = data.awards,
      awards = _data$awards === void 0 ? [] : _data$awards,
      _data$currentRecognit = data.currentRecognition,
      currentRecognition = _data$currentRecognit === void 0 ? [] : _data$currentRecognit,
      _data$recognition = data.recognition,
      recognition = _data$recognition === void 0 ? [] : _data$recognition,
      _data$settings = data.settings,
      settings = _data$settings === void 0 ? [] : _data$settings;

  var photos = (0, _helpers.mapPhotos)(_photos);
  var contact = (0, _helpers.mapPhones)(phones);
  var social = (0, _helpers.mapSocials)(socialLinks);
  return {
    id,
    organisationId: id,
    // deprecated
    parentId,
    branchIds,
    parentOrganisationId: parentId,
    // deprecated
    type,
    typeCode,
    subType,
    subTypeCode,
    sam: userName,
    name: name ? name.replace(new RegExp("^".concat(brandName, "\\s+")), '') : '',
    fullName: name,
    internalFullName: secondName || name,
    primaryPhone: contact.primary,
    primaryPhoneLocal: contact.primaryLocal,
    phone: contact.fix,
    // deprecated
    phoneLocal: contact.fixLocal,
    // deprecated
    promo: contact.promo,
    // deprecated
    promoLocal: contact.promoLocal,
    // deprecated
    officePhone: contact.fix,
    officePhoneLocal: contact.fixLocal,
    mobilePhone: contact.mob,
    mobilePhoneLocal: contact.mobLocal,
    promoPhone: contact.promo,
    promoPhoneLocal: contact.promoLocal,
    fax: contact.fax,
    faxLocal: contact.faxLocal,
    email: emailAddress,
    description: text,
    facebook: social.facebook,
    twitter: social.twitter,
    googlePlus: social.google,
    youtube: social.youtubechannel,
    linkedin: social.linkedin,
    pinterest: social.pinterest,
    instagram: social.instagram,
    video: social.videoprofile,
    testimonials,
    licenceCode,
    countryCode,
    address: mapAddress(address, subTypeCode === 'CORP'),
    postalAddress: mapAddress(postalAddress, subTypeCode === 'CORP'),
    website: webSite ? cleanWebsite(webSite) : undefined,
    roles,
    awards: (0, _helpers.cleanupAwards)(awards),
    recognitionLevels: currentRecognition,
    allRecognitionLevels: recognition,
    teams,
    imageExterior: photos.opext,
    imageReception: photos.oprcp,
    imageStaff: photos.opstf,
    imageTeam: photos.tpls,
    settings: reduceSettings(settings)
  };
};
/**
 * The data that we get back from ES is a giant mess. We need to
 * do quite a large map / reduce on it before we can do anything
 * with it.
 *
 * @param {Object} body - the JSON.parse()'d response body
 *
 * @returns {Object} the reduced response
 */


exports.mapOrganisation = mapOrganisation;

function cleanOrganisationMetadata(data) {
  var _context5, _context20, _context21, _context22, _context23;

  var total = data.hits.total,
      _typeCode = data.aggregations.typeCode;
  /* eslint-disable no-shadow, prefer-arrow-callback, no-param-reassign, func-names */

  var typeKey = (0, _reduce.default)(_context5 = _typeCode.buckets).call(_context5, function (previous, current) {
    var _context6, _context18;

    var key = current.key,
        _subTypeCode = current.subTypeCode;
    var subTypeCode = (0, _reduce.default)(_context6 = _subTypeCode.buckets).call(_context6, function (previous, current) {
      var _context7;

      var key = current.key,
          total = current.doc_count,
          _statusCode = current.statusCode;
      var statusCode = (0, _reduce.default)(_context7 = _statusCode.buckets).call(_context7, function (previous, current) {
        var _context8, _context13, _context16, _context17;

        var key = current.key,
            total = current.doc_count,
            _inspections = current.inspections,
            _auctions = current.auctions,
            _investments = current.investments,
            _prices = current.prices,
            _rentPrices = current.rentPrices,
            _categories = current.categories,
            _suburbs = current.suburb; // Load categories for the various property types

        var categories = (0, _reduce.default)(_context8 = _categories.category.buckets).call(_context8, function (result, _ref2) {
          var _context9, _context12;

          var key = _ref2.key,
              category = _ref2.category,
              location = _ref2.location;

          var _suburb = (0, _reduce.default)(_context9 = location.suburb.buckets).call(_context9, function (previous, current) {
            var _context10, _context11;

            var key = current.key,
                total = current.doc_count,
                _suburbId = current.suburbId,
                _postCode = current.postCode;
            var suburbId = (0, _map.default)(_context10 = _suburbId.buckets).call(_context10, function (_ref3) {
              var key = _ref3.key;
              return key;
            });
            var postCode = (0, _reduce.default)(_context11 = _postCode.buckets).call(_context11, function (previous, current) {
              var name = current.key,
                  total = current.doc_count;
              previous[name] = {
                total
              };
              return previous;
            }, {});
            previous[key] = {
              total,
              suburbId,
              postCode
            };
            return previous;
          }, {});

          (0, _forEach.default)(_context12 = category.buckets).call(_context12, function (data) {
            result.push({
              code: key,
              name: data.key,
              total: data.doc_count,
              suburb: _suburb
            });
          });
          return result;
        }, []); // Extract suburbs out of categories

        var suburb = (0, _reduce.default)(_context13 = _suburbs.buckets).call(_context13, function (acc, sub) {
          var _context14, _context15;

          acc[sub.key] = {
            postCode: (0, _reduce.default)(_context14 = sub.postCode.buckets).call(_context14, function (acc, pc) {
              acc[pc.key] = {
                total: pc.doc_count
              };
              return acc;
            }, {}),
            suburbId: (0, _map.default)(_context15 = sub.suburbId.buckets).call(_context15, function (sid) {
              return sid.key;
            }),
            total: sub.doc_count
          };
          return acc;
        }, {});
        var inspections = {
          total: _inspections.inspections.doc_count
        };
        var auctions = {
          total: _auctions.doc_count
        };
        var investments = {
          total: _investments.doc_count
        }; // Load prices for various types

        var prices = (0, _reduce.default)(_context16 = _prices.buckets).call(_context16, function (previous, current) {
          var price = current.key,
              total = current.doc_count;
          previous.push({
            price,
            total
          });
          return previous;
        }, []); // Load rentPrices for various types

        var rentPrices = (0, _reduce.default)(_context17 = _rentPrices.buckets).call(_context17, function (previous, current) {
          if (!current) return previous;
          var price = current.key,
              total = current.doc_count;
          previous.push({
            price,
            total
          });
          return previous;
        }, []);
        previous[key] = {
          total,
          suburb,
          inspections,
          auctions,
          investments,
          prices,
          rentPrices,
          // Drop off placeholder "NONE" categories, only needed for suburb counts
          categories: (0, _filter.default)(categories).call(categories, function (x) {
            return x.code !== 'NONE';
          })
        };
        return previous;
      }, {});
      previous[key] = {
        total,
        statusCode
      };
      return previous;
    }, {});
    var combined = (0, _reduce.default)(_context18 = (0, _keys.default)(subTypeCode)).call(_context18, function (result, subTypeCodeKey) {
      var _context19;

      var computed = (0, _concat.default)(_context19 = "".concat(key)).call(_context19, subTypeCodeKey && subTypeCodeKey !== 'NONE' ? subTypeCodeKey : '');
      result[computed] = _objectSpread({}, subTypeCode[subTypeCodeKey]);
      return result;
    }, {});
    return _objectSpread(_objectSpread({}, previous), combined);
  }, {
    total
  });
  var suburbs = {
    all: (0, _sort.default)(_context20 = (0, _suburbs2.getSuburbs)(typeKey)).call(_context20),
    SLD: (0, _sort.default)(_context21 = (0, _suburbs2.getSuburbs)(typeKey, 'SLD')).call(_context21),
    CUR: (0, _sort.default)(_context22 = (0, _suburbs2.getSuburbs)(typeKey, 'CUR')).call(_context22),
    LSE: (0, _sort.default)(_context23 = (0, _suburbs2.getSuburbs)(typeKey, 'LSE')).call(_context23)
  };
  return {
    typeKey,
    suburbs
  };
  /* eslint-enable no-shadow, prefer-arrow-callback, no-param-reassign, func-names */
}

var maxSize = 500;
/**
 * TODO: A template string would probably be much faster than just serializing
 * this JSON, moreover - these enourmous queries don't belong here.
 *
 * @param {Array} ids - an array of ids
 *
 * @returns {String} a JSON sting
 */

var agentMetadataDSL = function agentMetadataDSL(id, organisationIds, allowOtherTransactions) {
  var should = allowOtherTransactions ? [{
    terms: {
      statusCode: ['SLD', 'LSE']
    }
  }, {
    terms: {
      'office.organisationId': organisationIds
    }
  }] : [{
    terms: {
      'office.organisationId': organisationIds
    }
  }];
  return {
    size: 0,
    query: {
      bool: {
        must: [{
          terms: {
            listingStateCode: ['ACT']
          }
        }, {
          terms: {
            statusCode: ['CUR', 'SLD', 'LSE']
          }
        }, {
          nested: {
            path: 'agents',
            query: {
              bool: {
                must: {
                  term: {
                    'agents.memberId': id
                  }
                }
              }
            }
          }
        }],
        should: organisationIds && should,
        minimum_should_match: organisationIds && 1
      }
    },
    aggregations: {
      typeCodes: {
        terms: {
          field: 'typeCode'
        },
        aggregations: {
          subTypeCode: {
            terms: {
              field: 'subTypeCode'
            },
            aggregations: {
              statusCode: {
                terms: {
                  field: 'statusCode'
                }
              }
            }
          },
          statusCode: {
            terms: {
              field: 'statusCode'
            }
          }
        }
      }
    }
  };
};

exports.agentMetadataDSL = agentMetadataDSL;

var organisationMetadataDSL = function organisationMetadataDSL(priceInterval, ids) {
  var _context24, _context25;

  var sanePriceCriteria = [{
    // Ignore sale prices over 200,000,000
    range: {
      '_private._price': {
        lte: 200000000
      }
    }
  }, {
    // Ignore annual rent prices over 100,000
    range: {
      '_private._annualRentPrice': {
        lte: 100000
      }
    }
  }];
  var query = ids ? {
    bool: {
      must: (0, _concat.default)(_context24 = [{
        terms: {
          'office.organisationId': ids
        }
      }, {
        terms: {
          listingStateCode: ['ACT']
        }
      }, {
        terms: {
          statusCode: ['CUR', 'SLD', 'LSE']
        }
      }]).call(_context24, sanePriceCriteria)
    }
  } : {
    bool: {
      must: (0, _concat.default)(_context25 = [{
        terms: {
          listingStateCode: ['ACT']
        }
      }, {
        terms: {
          statusCode: ['CUR', 'SLD', 'LSE']
        }
      }]).call(_context25, sanePriceCriteria)
    }
  };
  return {
    size: 0,
    query,
    aggregations: {
      prices: {
        histogram: {
          field: '_private._price',
          interval: priceInterval
        }
      },
      typeCode: {
        terms: {
          field: 'typeCode',
          size: maxSize
        },
        aggregations: {
          subTypeCode: {
            terms: {
              field: 'subTypeCode',
              missing: 'NONE',
              size: maxSize
            },
            aggregations: {
              statusCode: {
                terms: {
                  field: 'statusCode',
                  size: maxSize
                },
                aggregations: {
                  suburb: {
                    terms: {
                      field: 'address.suburb.keyword',
                      size: maxSize
                    },
                    aggregations: {
                      postCode: {
                        terms: {
                          field: 'address.postCode',
                          size: maxSize
                        }
                      },
                      suburbId: {
                        terms: {
                          field: 'address.suburbId',
                          size: maxSize
                        }
                      }
                    }
                  },
                  auctions: {
                    filter: {
                      exists: {
                        field: 'auction'
                      }
                    }
                  },
                  inspections: {
                    nested: {
                      path: 'inspections'
                    },
                    aggregations: {
                      inspections: {
                        reverse_nested: {}
                      }
                    }
                  },
                  investments: {
                    filter: {
                      range: {
                        'investment.tenantedPercent': {
                          gte: 1
                        }
                      }
                    }
                  },
                  prices: {
                    histogram: {
                      field: '_private._price',
                      interval: priceInterval
                    }
                  },
                  rentPrices: {
                    histogram: {
                      field: '_private._annualRentPrice',
                      interval: 5000
                    }
                  },
                  categories: {
                    nested: {
                      path: 'categories'
                    },
                    aggregations: {
                      category: {
                        aggregations: {
                          category: {
                            terms: {
                              field: 'categories.category',
                              missing: 'NONE',
                              size: maxSize
                            }
                          },
                          location: {
                            reverse_nested: {},
                            aggregations: {
                              suburb: {
                                terms: {
                                  field: 'address.suburb.keyword',
                                  size: maxSize
                                },
                                aggregations: {
                                  postCode: {
                                    terms: {
                                      field: 'address.postCode',
                                      size: maxSize
                                    }
                                  },
                                  suburbId: {
                                    terms: {
                                      field: 'address.suburbId',
                                      size: maxSize
                                    }
                                  }
                                }
                              }
                            }
                          }
                        },
                        terms: {
                          field: 'categories.code',
                          size: maxSize
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      },
      members: {
        nested: {
          path: 'agents'
        },
        aggregations: {
          id: {
            terms: {
              field: 'agents.memberId',
              size: maxSize
            },
            aggregations: {
              listings: {
                reverse_nested: {},
                aggregations: {
                  typeCode: {
                    terms: {
                      field: 'typeCode',
                      size: maxSize
                    },
                    aggregations: {
                      subTypeCode: {
                        terms: {
                          field: 'subTypeCode',
                          size: maxSize
                        },
                        aggregations: {
                          statusCode: {
                            terms: {
                              field: 'statusCode',
                              size: maxSize
                            }
                          }
                        }
                      },
                      statusCode: {
                        terms: {
                          field: 'statusCode',
                          size: maxSize
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };
};

exports.organisationMetadataDSL = organisationMetadataDSL;